export default {
  appInfo: {
    // TODO: Translate (PWA)
    state: {
      configuration: 'Configurazione',
      downloaded: 'Scaricato',
      heading: "Informazioni sullo stato dell'applicazione",
      lastUpdated: 'Ultimo aggiornamento',
      noConfiguration: 'Nessuna configurazione disponibile',
      questionsAnswered: 'Nessuna domanda con risposta | {n} domanda con risposta | {n} domande con risposte',
      storedResponses: 'Risposte al sondaggio archiviate',
      surveyDetails: 'Dettagli Sondaggio',
      surveyInProgress: 'Un sondaggio è attualmente in corso',
      surveyNotInProgress: 'Non ci sono sondaggi attualmente in corso',
      surveyProgress: 'Progresso del Sondaggio',
      surveysAvailable: 'Nessun sondaggio disponibile | {n} sondaggio disponibile | {n} sondaggi disponibili',
      surveysStored: 'Nessuna risposta in attesa di caricamento | {n} risposta in attesa di caricamento | {n} risposte in attesa di caricamento',
      updateAvailable: 'Aggiornamento disponibile',
      updateDownloading: "Scaricamento dell'aggiornamento"
    },
    version: 'Versione App',
    sinceConfigUpdate: 'Not Implemented.',
    sinceSurveyUpload: 'Not Implemented.',
    sinceSurveyUploadYesterday: 'Not Implemented.',
    sinceMenuItemUpdate: 'Not Implemented.',
    appUpdated: 'Not Implemented.',
    install: {
      install: 'Not Implemented.',
      installTitle: 'Not Implemented.',
      installDesc: 'Not Implemented.',
      installInstructionsDesc: 'Not Implemented.',
      installInstructionsLabel: 'Not Implemented.',
      appInstalled: 'Not Implemented.',
      appInstalledDesc: 'Not Implemented.',
      iosPressShareButton: 'Not Implemented.',
      iosPressAddToHomescreen: 'Not Implemented.',
      unsupportedDeviceTitle: 'Not Implemented.',
      unsupportedDeviceDesc: 'Not Implemented.',
      unsupportedBrowserTitle: 'Not Implemented.',
      unsupportedBrowserDesc: 'Not Implemented.',
      pressMenuIcon: 'Not Implemented.',
      chromePressInstallApp: 'Not Implemented.',
      samsungPressAddPageTo: 'Not Implemented.',
      samsungPressHomeScreen: 'Not Implemented.',
      safari: 'Not Implemented.',
      samsungInternet: 'Not Implemented',
      chrome: 'Not Implemented.'
    }
  }
};